import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AiFillEye } from "react-icons/ai";
import BackArrows from "../../Form/BackArrow/BackArrows";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import MemberDetailsModal from "./MemberDetailsModal";
import ConfirmationModal from "../../shareableContainer/ConfirmationModal";
import { getIcons } from "../../Constant/Constant";
import NotFound from "../../Form/NotFound/NotFound";
import { TiTick } from "react-icons/ti";
import { HiMiniXMark } from "react-icons/hi2";
import CPManageService from "../../Services/CPManageService";
import Loader from "../../Constant/Loader";

const NewPermissionList = () => {
  const [members, setMembers] = useState([]);
  const [filter, setFilter] = useState("New");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [memberToToggle, setMemberToToggle] = useState(null);
  const [actionType, setActionType] = useState("");
  const icons = getIcons();

  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  const userId = userObj?.user?.uid;

  const getPermissionType = (filterValue) => {
    switch (filterValue) {
      case "New":
        return "pending";
      case "Accepted":
        return "approved";
      case "Refused":
        return "refused";
      default:
        return "pending";
    }
  };

  const fetchPermissions = async (type) => {
    setLoading(true);
    try {
      const response = await CPManageService.getPremissionList(type);
      setMembers(response.data);
      console.log(`permissions: ${JSON.stringify(response.data)}`);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const permissionType = getPermissionType(filter);
    fetchPermissions(permissionType);
  }, [filter]);

  const handleToggleClick = (member, action) => {
    setMemberToToggle(member);
    setActionType(action);
    setShowConfirmation(true);
  };

  const confirmTogglePermission = async () => {
    if (memberToToggle) {
      console.log(memberToToggle);
      setLoading(true);
      try {
        const newStatus = actionType === "accept" ? "approved" : "refused";

        const body = {
          uid: memberToToggle?.uid,
          permissionType: newStatus,
          onBoardedById: userId,
        };

        await CPManageService.updatePermissionStatus(body);

        const permissionType = getPermissionType(filter);
        await fetchPermissions(permissionType);
      } catch (error) {
        console.error("Error toggling permission:", error);
      } finally {
        setLoading(false);
        setShowConfirmation(false);
        setMemberToToggle(null);
        setActionType("");
      }
    }
  };

  const cancelTogglePermission = () => {
    setShowConfirmation(false);
    setMemberToToggle(null);
    setActionType("");
  };

  const openMemberDetails = async (member) => {
    try {
      const memberDetails = await CPManageService.getMemberDetails(member?.uid);
      setSelectedMember(memberDetails.data);
      setShowModal(true);
    } catch (error) {
      console.error(error);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedMember(null);
  };

  return (
    <div className="bg-appGrayBackground pb-16 min-h-screen">
       <AdminAppBar />
      <div className="mt-20 pt-8 px-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-6">
            <BackArrows onClick={() => navigate(-1)} />
            <h1 className="text-[32px] font-semibold">New Permission</h1>
          </div>
        </div>

        <div className="my-6 flex justify-start border-b border-gray-200">
          {["New", "Accepted", "Refused"].map((tab) => (
            <button
              key={tab}
              className={`px-6 py-3 text-lg font-medium transition-all border-b-4 ${
                filter === tab
                  ? "border-customGreen text-customGreen font-semibold"
                  : "text-gray-500 hover:text-gray-700 border-transparent hover:border-gray-300"
              }`}
              onClick={() => setFilter(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="overflow-x-auto bg-white shadow-md rounded-lg">
          <table className="min-w-full border-collapse">
            <thead>
              <tr className="bg-gray-100 px-5 text-center text-gray-700">
                <th className="px-6 py-3 border-b">User Name</th>
                <th className="px-6 py-3 border-b">Requested Date</th>
                <th className="px-6 py-3 border-b">Permission</th>
                <th className="px-6 py-3 border-b">Action</th>
              </tr>
            </thead>
            <tbody className="">
              {loading ? (
                <tr>
                  <td colSpan="4" className="text-center py-4 text-gray-500">
                    <Loader />
                  </td>
                </tr>
              ) : members.length > 0 ? (
                members.map((member) => (
                  <tr key={member.id} className="hover:bg-gray-50 text-center">
                    <td className="px-6 py-4 border-b">{member.name}</td>
                    <td className="px-6 py-4 border-b">
                      {member.requestedDate}
                    </td>
                    <td className="px-4 py-2 border-b">
                      {filter === "New" ? (
                        <div className="flex items-center justify-center gap-6">
                          <button
                            onClick={() => handleToggleClick(member, "accept")}
                            className="flex items-center gap-2"
                          >
                            <div className="bg-customGreen w-5 h-5 flex items-center justify-center rounded-full">
                              <TiTick className="text-white text-sm" />
                            </div>
                            <span className="text-green-600 text-sm font-semibold">
                              Accept
                            </span>
                          </button>

                          <button
                            onClick={() => handleToggleClick(member, "refuse")}
                            className="flex items-center gap-2"
                          >
                            <div className="bg-red-600 w-5 h-5 flex items-center justify-center rounded-full">
                              <HiMiniXMark className="text-white text-sm" />
                            </div>
                            <span className="text-red-600 text-sm font-semibold">
                              Refuse
                            </span>
                          </button>
                        </div>
                      ) : (
                        <div className="flex items-center justify-center gap-2">
                                                    <span
                            className={`text-sm font-medium transition-colors ${
                              filter === "Accepted"
                                ? "text-gray-900"
                                : "text-red-600"
                            }`}
                          >
                            Refuse
                          </span>

                          <label className="inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="sr-only peer"
                              checked={filter === "Accepted"}
                              onChange={() => {
                                const action =
                                  filter === "Accepted" ? "refuse" : "accept";
                                handleToggleClick(member, action);
                              }}
                            />
                            <div
                              className={`relative w-11 h-6 rounded-full peer 
                              ${
                                filter === "Accepted"
                                  ? "bg-green-500 after:translate-x-full"
                                  : "bg-red-500 after:translate-x-0"
                              } 
                              after:content-[''] after:absolute after:top-0.5 after:left-[2px] 
                              after:bg-white after:border-gray-300 after:border after:rounded-full 
                              after:h-5 after:w-5 after:transition-all`}
                            ></div>
                          </label>
                          <span
                            className={`text-sm font-medium transition-colors ${
                              filter === "Accepted"
                                ? "text-green-600"
                                : "text-gray-900"
                            }`}
                          >
                            Accept
                          </span>

                        </div>
                      )}
                    </td>

                    <td className="px-6 py-4 border-b">
                      <button
                        className="text-gray-600 hover:text-gray-900"
                        onClick={() => openMemberDetails(member)}
                      >
                        <AiFillEye className="text-xl" />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center py-4 text-gray-500">
                    <NotFound title={"No records found"} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showConfirmation && memberToToggle && (
        <ConfirmationModal
          showModal={showConfirmation}
          icon={icons?.infoIcon}
          title={"Are You Sure?"}
          message={`Are you sure you want to ${
            actionType === "accept" ? "accept" : "refuse"
          } ${memberToToggle.name}'s permission?`}
          onConfirm={confirmTogglePermission}
          onCancel={cancelTogglePermission}
        />
      )}

      {showModal && selectedMember && (
        <MemberDetailsModal
          selectedMember={selectedMember}
          closeModal={closeModal}
        />
      )}
    </div>
  );
};

export default NewPermissionList;
